__turbopack_context__.v({
  "checkbox": "tK062G_checkbox" + " " + __turbopack_context__.i(248112)["resetFocusOutline"],
  "label": "tK062G_label",
  "supportingText": "tK062G_supportingText",
  "textWrapper": "tK062G_textWrapper",
  "textWrapperVertical": "tK062G_textWrapperVertical",
  "wrapper": "tK062G_wrapper" + " " + __turbopack_context__.i(248112)["focusWithinOutline"],
});
